import React from "react";
import { Card, Flex, Text, Link } from "@jsq/ds/core";
import { PaymentDetailField } from "../../PaymentDetailField";
import {
  cardTitle,
  contentContainer,
  fieldRow,
  fieldLabel,
  fieldValue,
  fieldValueColumn,
} from "./styles_vanilla.css";
import { PayeeDetailsCardProps } from "./types";

const getPayeeTypeLabel = (payeeType: string): string => {
  switch (payeeType) {
    case "vendor":
      return "Vendor";
    case "entity":
      return "Entity";
    case "investment":
      return "Investment";
    default:
      return "Payee";
  }
};

export const PayeeDetailsCard: React.FC<PayeeDetailsCardProps> = ({
  payeeName,
  payeeType,
  address,
  taxId,
  taxFormLabel,
  primaryPayeeDocument,
  form1099Required,
}) => {
  const addressLines = address
    ? [
        address.street,
        address.street2,
        address.street3,
        address.city,
        address.state?.name || address.region,
        address.postalCode,
        address.country?.name,
      ].filter(Boolean)
    : [];

  return (
    <Card padding="lg">
      <Text className={cardTitle} variant="secondary-md">
        PAYEE DETAILS
      </Text>
      <Flex flexDirection="column" gap={16} className={contentContainer}>
        {payeeName && (
          <PaymentDetailField label={getPayeeTypeLabel(payeeType)} value={payeeName} />
        )}

        {addressLines.length > 0 && (
          <Flex className={fieldRow}>
            <Flex className={fieldLabel}>
              <Text variant="secondary-md">Address</Text>
            </Flex>
            <Flex className={fieldValueColumn}>
              {addressLines.map((line, index) => (
                <Text key={index} variant="regular-md">
                  {line}
                </Text>
              ))}
            </Flex>
          </Flex>
        )}

        {taxId && <PaymentDetailField label="Tax ID" value={taxId} />}

        {(taxFormLabel || (primaryPayeeDocument && primaryPayeeDocument.viewUrl)) && (
          <Flex flexDirection="column">
            {taxFormLabel && (
              <Flex className={fieldRow}>
                <Flex className={fieldLabel}>
                  <Text variant="secondary-md">Tax form</Text>
                </Flex>
                <Flex className={fieldValue}>
                  <Text variant="regular-md">{taxFormLabel}</Text>
                </Flex>
              </Flex>
            )}

            {primaryPayeeDocument && primaryPayeeDocument.viewUrl && (
              <Flex className={fieldRow}>
                <Flex className={fieldLabel}></Flex>
                <Flex className={fieldValue}>
                  <Link
                    href={primaryPayeeDocument.viewUrl}
                    shouldOpenInNewTab
                    align="left"
                    icon="external-link"
                    iconPosition="right"
                  >
                    {primaryPayeeDocument.name}
                  </Link>
                </Flex>
              </Flex>
            )}
          </Flex>
        )}

        {form1099Required !== null && form1099Required !== undefined && (
          <PaymentDetailField label="1099 Required" value={form1099Required ? "Yes" : "No"} />
        )}
      </Flex>
    </Card>
  );
};
